    <spinner [id]="'approveinfo'" [show]='activeSpinner'></spinner>
    <div class="modal-header mb-2">
        <h5 class="modal-title"><i class="fa fa-eye" aria-hidden="true"></i> {{'viewreprt.Information for' | translate}} {{'districtsdata.' + statename | translate}}</h5>
        <button type="button" class="close pointer" (click)="activeModal.dismiss('cancel click')">
            <span aria-hidden="true">×</span>
        </button>
    </div>
    <div class="modal-body p-0">
        <div id="approvalhistory" >
                <div class="table-responsive" *ngIf="type !='admin-weightage'">
                    <table class="table table-sm table-dark m-0">
                        <thead>
                            <tr class="text-center  ">
                                <th scope="col">{{'trigManage.sno' | translate}}</th>
                                <th scope="col">{{'dataSubs.indicator' | translate}}</th>
                                <th *ngIf="!dgcvalidation" scope="col">{{'infotab.rank' | translate}}</th>
                                <th scope="col">{{'setDropDown.ActualValue' | translate}}</th>
                                <th scope="col" *ngIf="!dgcvalidation">{{'dataSubs.scoregen' | translate}}</th>
                                <th scope="col" *ngIf="dgcvalidation">{{'dataSubs.Y Value' | translate}}</th>
                                <th scope="col" *ngIf="dgcvalidation">{{'dataSubs.Manual Value' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                                <tr *ngFor="let row of reportTableData; let i=index">
                                        <td>{{row['sno']}}</td>
                                        <td >{{'indicatorlist.' + row['name'] | translate}}</td>
                                        <td *ngIf="!dgcvalidation">{{row['rank'] ? row['rank'] : ''}}</td>
                                        <td>{{row['actualval'] ? row['actualval'] : ''}}</td>
                                        <td>{{checkscorevalue(row['score'])}}</td>
                                        <td *ngIf="dgcvalidation && row['rank']"><input  type="text" class="input-style" style="width: 100%;"  [(ngModel)]="row['manualV']"(ngModelChange) = "indicatorValueChange(row)" appFloatwithMinmax [min]="" [max]=""></td>
                                    </tr>
                        </tbody>
                    </table> 
                    </div>

                    <div class="table-responsive" *ngIf="type =='admin-weightage'">
                    <table class="table table-sm table-dark m-0">
                        <thead>
                            <tr class="text-center">
                                <th scope="col">{{'trigManage.sno' | translate}}</th>
                                <th scope="col">{{'dataSubs.indicator' | translate}}</th>
                                <th scope="col">{{'dataSubs.Weightage' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of indicatorTableData; let i=index">
                                <td>{{row['type'] != 'THEME' ? row['sno'] : ''}}</td>
                                <td [style.text-align] = "row['type'] == 'THEME' ? 'center' : 'left'" >{{row['label']}}</td>
                                <td>{{row['type'] != "THEME" ? checkvalue(row['value']) : ''}}</td>
                            </tr>
                        </tbody>
                    </table> 
                    </div>
                    <div class="row" *ngIf="dgcvalidation">
                        <div class="col-md-10"></div>
                        <div class="col-md-2">
                        <button style="margin-top: 20px;" class="btn btn-info pointer" (click)="submitModifyData()" type="submit">{{'dataSubs.SUBMIT' | translate }}</button>
                        </div>
                    </div>
        </div>
    </div>